const data = [
  {
    school: "Nanyang Technological University, Singapore",
    stream: "Bachelor of Engineering (Computer Science)",
    date: "Aug 2020 - June 2024 (Expected)",
    achievements: [
      "Expected Honours (Distinction)",
      "Relevant Courses: Software Engineering, Object Oriented Design and Programming, Intro to Database",
    ],
  },
  {
    school: "Penabur 6 High School, Indonesia",
    stream: "Science Stream",
    date: "July 2017 - May 2020",
    achievements: [
      "Ranked 17th for 2020 Science Stream Cohort",
      "Joined Astronomy Olympiad for 2018 and 2019 (Province Level)",
    ],
  },
];

export default data;
